import { render } from "./PhotoPeriodSettings.vue?vue&type=template&id=4e4218c8&scoped=true"
import script from "./PhotoPeriodSettings.vue?vue&type=script&lang=js"
export * from "./PhotoPeriodSettings.vue?vue&type=script&lang=js"

import "./PhotoPeriodSettings.vue?vue&type=style&index=0&id=4e4218c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e4218c8"

export default script